/** Copyright (c) 2019 T.Rowe Price. All rights reserved. */

import { RECEIVED_METADATA } from 'state/api/MetadataActions';

export const metadataInitialState = {
  states: {},
  countries: {},
  militaryStates: {},
  militaryCities: {}
};

export const metadataReducer = (state = {}, action) => {
  if (action.type !== RECEIVED_METADATA) {
    return state;
  }
  return action.metadata;
};
